import { api } from "./configs/axiosConfigs"

export const SpecificSubcategoryAPI = {
    
    getSpecificsubcategories: async (data:any) => {
        const response = await api.get(
            '/specificsubcategory', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getSpecificsubcategoriesByCompany: async (data:any) => {
        const response = await api.get(
            '/specificsubcategory/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getSpecificsubcategoriesBySubCategory: async (data:any) => {
        const response = await api.get(
            '/specificsubcategory/listBySubcategory', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createSpecificsubcategory: async (data: any) => {
        const response = await api.post(
            '/specificsubcategory/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editSpecificsubcategory: async (idcategory: number, data: any) => {
        const response = await api.patch(
            `/specificsubcategory/${idcategory}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteSpecificsubcategory: async (idcategory: number) => {
        const response = await api.delete(
            `/specificsubcategory/${idcategory}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}